import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useSelector } from 'react-redux'
import { Button, SpeakerIcon } from '@astrid/components'
import usePlayer from 'hooks/usePlayer'
import { EnglishDialect, selectEnglishDialect } from 'store/services/User'

export const InjectListenButton = ({ exercise }) => {
  const englishDialect = useSelector(selectEnglishDialect)

  const [container, setContainer] = useState<Element | null>(null)

  const assistantPlayer = usePlayer(true)

  useEffect(() => {
    const root = document.querySelector('.comprehension-exercise')
    const paragraph = root?.querySelector('p')

    if (!root || !paragraph) return

    const mount = document.createElement('div')

    root.insertBefore(mount, paragraph)

    setContainer(mount)

    return () => {
      mount.remove()
    }
  }, [])

  const startAssistant = async () => {
    await assistantPlayer.stopSound()
    await assistantPlayer.playSound({
      path: englishDialect === EnglishDialect.EnGB ? exercise.data.audioQuestion : exercise.data.audioQuestionUs
    })
  }

  const isComprehensionExercise = exercise.type === 'MultiChoiseQuestion'
  const canListenQuestion = exercise.data.questionType === 'Audio'

  const shouldMountListenButton = isComprehensionExercise && canListenQuestion

  useEffect(() => {
    if (container && shouldMountListenButton) {
      setTimeout(() => {
        startAssistant()
      }, 500)
    }
  }, [container, shouldMountListenButton])

  if (!container || !shouldMountListenButton) return null

  return createPortal(
    <Button type="button" aria-label="Listen question" onClick={startAssistant}>
      <SpeakerIcon />
    </Button>,
    container
  )
}
